import React from "react";
import { DEFAULT_AREA } from "../admin/Area";
import { TokenPolicy } from "./TokenPolicy";
import { AiiaPolicy } from "./AiiaPolicy";
import { IPolicy } from "../../generated/models/policy";

export const Policy = (props: IPolicy) => {
  if (!props.area) return <></>;

  return props.area === DEFAULT_AREA ? (
    <TokenPolicy {...props} providerId={props.providerId || "provider"} />
  ) : (
    <AiiaPolicy {...props} providerId={props.providerId || "provider"} />
  );
};

Policy.defaultProps = {
  buttonPosition: "above",
  missionType: null,
};
